module.exports = __webpack_public_path__ + "img/icon-2.f30fb885.png";